import React from 'react'
import BackButton from './BackButton'
import TransactionDetailsJ1 from './TransactionDetailsJ1'
import FloatingIcon from '../General/FloatingIcon'


function Ras() {
  return (
    <div>
      <BackButton/> 
      <TransactionDetailsJ1/>   
      <FloatingIcon/>    
    </div>
  )
}

export default Ras